import React from "react";

class GradientSVG extends React.Component {
  render() {
    let { startColor, endColor, idCSS, rotation } = this.props;

    let gradientTransform = `rotate(${rotation ? rotation : 0})`;

    return (
      <svg style={{ height: 0, position: "absolute" }}>
        <defs>
          <linearGradient
            id={"gradient-id"}
            gradientTransform={gradientTransform}
          >
            <stop offset="0%" stopColor={startColor} />
            <stop offset="100%" stopColor={endColor} />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default GradientSVG;
